import React from 'react';
import NumberInput from './NumberInput';

function MoneyInput({
  label,
  layout = 'default',
  unit = '$',
  name,
  description,
  required,
  preValue,
  maxValue,
}) {
  return (
    <NumberInput
      name={name}
      label={label}
      layout={layout}
      unit={unit}
      description={description}
      required={required}
      preValue={preValue}
      maxValue={maxValue}
    />
  );
}

export default MoneyInput;
